// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2N2t1","author":"Table_author__19wxY","authorImage":"Table_authorImage__3B3-u","unreadRow":"Table_unreadRow__2Q1UE"};